import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PasswordValidation } from '../change-password/change-password.component';
import { BaseComponent } from '../../base/base.component';
import { UserService } from '../../../services/user.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-password-update',
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.css'],
  standalone: false,
})
export class PasswordUpdateComponent extends BaseComponent implements OnInit {
  // UI bind properties
  resetPasswordForm: FormGroup = new FormGroup({});
  passwordUpdated: boolean = false;
  passwordUpdateFailed: boolean = false;
  isTokenValid: boolean = false;
  isTokenInvalid: boolean = false;
  isActivateAccount = false;

  // local properties
  private resetToken: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private fb: FormBuilder,
  ) {
    super();
  }

  ngOnInit() {
    this.passwordUpdated = false;
    this.isTokenValid = false;
    this.isTokenInvalid = false;
    this.resetToken = '';

    this.resetPasswordForm = this.fb.group(
      {
        credential: ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*[_!@#$%^&*()])(?=.*?[0-9]).{8,}$')]],
        confirmCredential: ['', Validators.required],
      },
      { validator: PasswordValidation.PasswordMatch },
    );

    this.route.queryParams.subscribe((params) => {
      this.isActivateAccount = false;
      if (params.ResetLinkToken) {
        this.validateResetPasswordToken(params.ResetLinkToken);
      } else if (params.ActivateAccountToken) {
        this.isActivateAccount = true;
        this.validateResetPasswordToken(params.ActivateAccountToken);
      } else {
        this.isTokenInvalid = true;
      }
    });

    setTimeout(() => {
      this.backToLoginPage();
    }, 300000); // Redirect to login page after 5 minutes
  }

  public get form() {
    return this.resetPasswordForm.controls;
  }

  public onBackToHomePage(): void {
    this.router.navigate(['']);
  }

  public onResetPasswordPage(): void {
    this.router.navigate(['password-reset']);
  }

  onSubmit() {
    const formModel = this.resetPasswordForm.value;
    if (this.resetPasswordForm.invalid) {
      return;
    } else {
      this.updatePassword(this.resetToken, formModel.confirmCredential);
    }
  }

  private validateResetPasswordToken(token: string): void {
    this.userService.validateResetPasswordToken(token).subscribe(
      (data) => {
        if (data) {
          this.isTokenValid = true;
          this.resetToken = token;
        } else {
          this.isTokenInvalid = true;
          // console.log(data);
        }
      },
      (err) => {
        this.isTokenInvalid = true;
        console.error(err);
      },
    );
  }

  private updatePassword(token: string, newPassword: string): void {
    const validateResetPasswordTokenPromise = this.userService.updatePassword(token, newPassword).toPromise();
    validateResetPasswordTokenPromise.then(
      (data) => {
        if (data) {
          this.passwordUpdated = data;
        }
      },
      (err) => {
        this.passwordUpdateFailed = true;
        console.log(err);
      },
    );
  }

  public backToLoginPage(): void {
    this.router.navigate(['/']);
  }
}
